import { render, staticRenderFns } from "./ModalPP.vue?vue&type=template&id=61c9abc8&scoped=true"
import script from "./ModalPP.vue?vue&type=script&lang=js"
export * from "./ModalPP.vue?vue&type=script&lang=js"
import style0 from "./ModalPP.vue?vue&type=style&index=0&id=61c9abc8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c9abc8",
  null
  
)

export default component.exports